<script>
// Anel SVG genérico, puramente visual. Reaproveita a geometria do anel usado no
// modal de transcrição (viewBox 48×48, r=20, stroke-width 5, rotate(-90 24 24)),
// generalizada para qualquer escala (value/max) e qualquer cor de arco/trilha.
// O conteúdo central vem por slot — o componente não conhece nota/sentimento,
// apenas desenha o anel proporcional.
const RING_RADIUS = 20
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS

export default {
  name: 'TranscriptRingGauge',
  props: {
    // Valor preenchido (na escala 0..max).
    value: { type: Number, default: 0 },
    // Valor máximo da escala (100 para sentimento, 10 para nota).
    max: { type: Number, default: 100 },
    // Cor do arco preenchido (aceita hex ou var(--token)).
    color: { type: String, default: 'var(--gray-5)' },
    // Cor da trilha (anel de fundo).
    trackColor: { type: String, default: '#E4E4E4' },
    // Diâmetro do anel em px.
    size: { type: Number, default: 96 },
  },
  data() {
    return { ringCircumference: RING_CIRCUMFERENCE }
  },
  computed: {
    // Fração preenchida (0..1), travada nos limites para nunca estourar o arco.
    fraction() {
      if (!this.max) return 0
      const ratio = this.value / this.max
      if (ratio < 0) return 0
      if (ratio > 1) return 1
      return ratio
    },
    // Arco preenchido: quanto maior a fração, menor o offset (mais anel pintado).
    ringOffset() {
      return this.ringCircumference * (1 - this.fraction)
    },
    ringStyle() {
      return { width: this.size + 'px', height: this.size + 'px' }
    },
  },
}
</script>

<template>
  <div class="transcript-ring-gauge" :style="ringStyle">
    <svg viewBox="0 0 48 48" width="100%" height="100%">
      <circle
        cx="24"
        cy="24"
        :r="20"
        fill="none"
        :stroke="trackColor"
        stroke-width="5"
      />
      <circle
        cx="24"
        cy="24"
        :r="20"
        fill="none"
        :stroke="color"
        stroke-width="5"
        stroke-linecap="round"
        :stroke-dasharray="ringCircumference"
        :stroke-dashoffset="ringOffset"
        transform="rotate(-90 24 24)"
      />
    </svg>
    <span class="transcript-ring-gauge__content">
      <slot />
    </span>
  </div>
</template>

<style lang="sass" scoped>
// Apenas layout: o anel ocupa o tamanho da prop e centraliza o slot por cima.
.transcript-ring-gauge
  position: relative
  flex-shrink: 0

  &__content
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    line-height: 1
</style>
